import React from "react";
import { SelectBox, TextInput } from "../../component/styled";

const TelField = ({
  label,
  options,
  itemKey,
  value = {},
  onChange,
  hasButton,
  buttonClick = null,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange(itemKey, name, value);
  };

  return (
    <li className={itemKey}>
      <span className="tit">{label}</span>
      <div className="cont">
        <SelectBox name="areaCode" value={value.areaCode || ""} onChange={handleChange}>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </SelectBox>
        <TextInput
          type="text"
          name="firstPart"
          value={value.firstPart || ""}
          onChange={handleChange}
          maxLength={4}
        />
        <TextInput
          type="text"
          name="secondPart"
          value={value.secondPart || ""}
          onChange={handleChange}
          maxLength={4}
        />
        {hasButton && <button onClick={buttonClick}>{hasButton}</button>}
      </div>
    </li>
  );
};

export default TelField;
